import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import ar from "./locales/ar.json";
import assistantAiEn from "./locales/assistantAi.en.json";
import assistantAiFr from "./locales/assistantAi.fr.json";
import assistantAiAr from "./locales/assistantAi.ar.json";

import availEn from "../availabilityDoctor/locales/availability.en.json";
import availFr from "../availabilityDoctor/locales/availability.fr.json";
import availAr from "../availabilityDoctor/locales/availability.ar.json";

import waitingRoomEn from "../WaitingRoom/locale/waitingRoom.en.json";
import waitingRoomFr from "../WaitingRoom/locale/waitingRoom.fr.json";
import waitingRoomAr from "../WaitingRoom/locale/waitingRoom.ar.json";

import sousProfileEn from "../sous-profile/locales/sousProfile.en.json";
import sousProfileFr from "../sous-profile/locales/sousProfile.fr.json";
import sousProfileAr from "../sous-profile/locales/sousProfile.ar.json";

import cabinetDashboardEn from "../cabinetDashboard/locales/cabinetDashboard.en.json";
import cabinetDashboardFr from "../cabinetDashboard/locales/cabinetDashboard.fr.json";
import cabinetDashboardAr from "../cabinetDashboard/locales/cabinetDashboard.ar.json";

import appointmentsEn from "../appointments/locales/appointments.en.json";
import appointmentsFr from "../appointments/locales/appointments.fr.json";
import appointmentsAr from "../appointments/locales/appointments.ar.json";
import cycleEn from "../cycle/locales/cycle.en.json";
import cycleFr from "../cycle/locales/cycle.fr.json";
import cycleAr from "../cycle/locales/cycle.ar.json";

import cnamBookEn from "../Profile/locales/cnamBook.en.json";
import cnamBookFr from "../Profile/locales/cnamBook.fr.json";
import cnamBookAr from "../Profile/locales/cnamBook.ar.json";

import patientsListEn from "../consultation/locales/patientsList.en.json";
import patientsListFr from "../consultation/locales/patientsList.fr.json";
import patientsListAr from "../consultation/locales/patientsList.ar.json";

/* ✅ Landing Page */
import landingPageEn from "../Landing/locale/landingPage.en.json";
import landingPageFr from "../Landing/locale/landingPage.fr.json";
import landingPageAr from "../Landing/locale/landingPage.ar.json";

import neurologueEn from "../specialty/neurologue/locales/neurologue.en.json";
import neurologueFr from "../specialty/neurologue/locales/neurologue.fr.json";
import neurologueAr from "../specialty/neurologue/locales/neurologue.ar.json";
import pulmonologyEn from "../specialty/pulmonology/locales/pulmonology.en.json";
import pulmonologyFr from "../specialty/pulmonology/locales/pulmonology.fr.json";
import pulmonologyAr from "../specialty/pulmonology/locales/pulmonology.ar.json";
import radioEn from "../navigation/locales/radio.en.json";
import radioFr from "../navigation/locales/radio.fr.json";
import radioAr from "../navigation/locales/radio.ar.json";

const resources = {
  en: {
    translation: en,
    assistantAi: assistantAiEn,
    availability: availEn,
    waitingRoom: waitingRoomEn,
    sousProfile: sousProfileEn,
    cabinetDashboard: cabinetDashboardEn,
    appointments: appointmentsEn,
    patientsList: patientsListEn,
    cnamBook: cnamBookEn,
    cycle: cycleEn,
        landingPage: landingPageEn,
      neurologue: neurologueEn,
      pulmonology: pulmonologyEn,
      radio: radioEn,

  },
  fr: {
    translation: fr,
    assistantAi: assistantAiFr,
    availability: availFr,
    waitingRoom: waitingRoomFr,
    sousProfile: sousProfileFr,
    cabinetDashboard: cabinetDashboardFr,
    appointments: appointmentsFr,
    patientsList: patientsListFr,
    cnamBook: cnamBookFr,
    cycle: cycleFr,
        landingPage: landingPageFr,
      neurologue: neurologueFr,
      pulmonology: pulmonologyFr,
      radio: radioFr,

  },
  ar: {
    translation: ar,
    assistantAi: assistantAiAr,
    availability: availAr,
    waitingRoom: waitingRoomAr,
    sousProfile: sousProfileAr,
    cabinetDashboard: cabinetDashboardAr,
    appointments: appointmentsAr,
    patientsList: patientsListAr,
    cnamBook: cnamBookAr,
    cycle: cycleAr,
    landingPage: landingPageAr,
    neurologue: neurologueAr,
    pulmonology: pulmonologyAr,
    radio: radioAr,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,

    ns: [
      "translation",
      "assistantAi",
      "availability",
      "waitingRoom",
      "sousProfile",
      "cabinetDashboard",
      "appointments",
      "patientsList",
      "landingPage",
      "cycle",
      "neurologue",
      "pulmonology",
      "radio",
    ],

    defaultNS: "translation",

    fallbackLng: "en",
    supportedLngs: ["en", "fr", "ar"],

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "medilink-lang",
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

const applyLanguageDirection = (lng) => {
  const currentLng = lng || i18n.language || "en";
  const dir = currentLng === "ar" ? "rtl" : "ltr";

  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", currentLng);
};

i18n.on("languageChanged", applyLanguageDirection);
applyLanguageDirection(i18n.language);

export default i18n;
